import Region from "./Region";

class ProteinRegion {
  constructor(data, chr) {
    this.id = `${data.description}-${data.position}-${data.length}`;
    this.protein = data.protein || "";
    this.description = data.description || "";
    this.aminoAcid = data["amino-acid"] || "";
    this.type = data.type;
    this.color = data.colour;
    this.level = 0;

    const start = data.position;
    const end = start + data.length;

    this.region = new Region(start, end, chr);
  }
}

export default ProteinRegion;
